// /frontend/src/components/JobFilters.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Paper, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

// 1. Funzione helper per generare la lista degli ultimi 24 mesi
const generateMonthOptions = () => {
  const options = [];
  const date = new Date();
  for (let i = 0; i < 24; i++) {
    const label = date.toLocaleString('it-IT', { month: 'long', year: 'numeric' });
    const value = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    options.push({ value, label });
    date.setMonth(date.getMonth() - 1);
  }
  return options;
};

const JobFilters = ({ onSearch }) => {
  // 2. Aggiungiamo 'month' allo stato iniziale dei filtri
  const [filters, setFilters] = useState({ search: '', category: '', month: '' });
  const [categories, setCategories] = useState([]);
  const [monthOptions] = useState(generateMonthOptions()); // Generiamo le opzioni una sola volta

  useEffect(() => {
    axios.get('/api/categories')
      .then(res => setCategories(res.data))
      .catch(err => console.error("Errore nel caricare le categorie per i filtri", err));
  }, []);

  const handleChange = (e) => {
    setFilters(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSearch = () => {
    onSearch(filters);
  };

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      {/* 3. Aggiustiamo la griglia per fare spazio al nuovo filtro (es. 4-3-3-2) */}
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            name="search"
            label="Cerca per parola chiave, azienda..."
            variant="outlined"
            size="small"
            value={filters.search}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Categoria</InputLabel>
            <Select
              name="category"
              value={filters.category}
              label="Categoria"
              onChange={handleChange}
            >
              <MenuItem value=""><em>Tutte le categorie</em></MenuItem>
              {categories.map(cat => (
                <MenuItem key={cat.id} value={cat.name}>{cat.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* 4. Aggiungiamo il nuovo menù a tendina per il mese */}
        <Grid item xs={12} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Mese di Pubblicazione</InputLabel>
            <Select
              name="month"
              value={filters.month}
              label="Mese di Pubblicazione"
              onChange={handleChange}
            >
              <MenuItem value=""><em>Qualsiasi mese</em></MenuItem>
              {monthOptions.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} md={2}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleSearch}
            startIcon={<SearchIcon />}
          >
            Cerca
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default JobFilters;